// src/config/site.ts
export const siteConfig = {
  siteName: 'MeetMinutes',
  title: 'MeetMinutes | AI Meeting Assistant & Notetaker',
  description: 'MeetMinutes uses AI to record, transcribe, summarize, and analyze your meetings, capturing key decisions and action items automatically.',
  siteUrl: 'https://meetminutes.ai',
  strapiUrl: 'https://dev-strapi.kortexitylab.com',
  ogImage: 'https://meetminutes.ai/images/logo/logo.png',
};
 